import { ShieldIcon } from '../components/ShieldIcon';
import type { SportEventTypeConfig } from './types';

/**
 * Cross-sport event types that every sport module includes.
 *
 * These aren't emitted by any single sport's SES wire format — they're
 * produced elsewhere (custom events come from the DB's custom-events endpoint)
 * yet must render in every sport's play-by-play. They historically lived only
 * in the NHL catalog, which silently broke them for other sports: the panel's
 * display filter is scoped to the *active* sport module (see
 * `useActiveSportEventTypes` -> `backendEventTypes` -> `setFilter`), so a type
 * declared only under NHL is filtered out of an NBA game's timeline entirely.
 *
 * Declaring them here and spreading them into each `<sport>/eventTypes.ts`
 * keeps a single source of truth and guarantees every sport allow-lists them.
 */
export const COMMON_EVENT_TYPES: ReadonlyArray<SportEventTypeConfig> = [
  {
    type: 'custom',
    fetchFromBackend: true,
    showFilterPill: true,
    displayName: 'Custom Events',
    description: 'User-created events',
    hideTeamLogo: true,
    icon: ShieldIcon,
  },
];
